import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["name", "id", "type", "value", "min", "maxlength", "disabled", "placeholder", "readonly"]
const _hoisted_2 = {
  key: 0,
  class: "invalid-feedback",
  role: "alert"
}

import {toRef} from "vue";

export default /*@__PURE__*/_defineComponent({
  ...{
    inheritAttrs: false,
},
  __name: 'TextInput',
  props: {
    type: {
        type: String,
        default: "text",
        required: false,
    },
    value: {
        type: [String, null],
        default: "",
    },
    modelValue: {
        type: [String, null],
        default: "",
    },
    name: {
        type: String,
        required: true,
    },

    error: {
        type: String,
        default: null,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    placeholder: {
        type: [String],
        default: "",
    },
    maxLength: {
        type: Number,
        default: null,
    },
    min: {
        type: Number,
        default: null,
    },
    readonly: {
        type: Boolean,
        default: false,
    },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {


const props = __props;

const emit = __emit;

const name = toRef(props, "name");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("input", {
      name: name.value,
      id: name.value,
      type: __props.type,
      value: props.modelValue,
      min: __props.min,
      maxlength: __props.maxLength,
      class: _normalizeClass(["form-control", {'is-invalid': !!__props.error}]),
      disabled: __props.disabled,
      placeholder: __props.placeholder,
      readonly: __props.readonly,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event.target.value)))
    }, null, 42, _hoisted_1),
    _renderSlot(_ctx.$slots, "append"),
    (__props.error)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.error), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})